import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { database } from './firebase';
import { ref, get } from 'firebase/database';
import { PET_SIZES, PET_STATUS ,PET_TYPES} from './constants';
import AdoptionForm from './adopciones/AdoptionForm';


const PetDetail = () => {
  const { petId } = useParams();
  const navigate = useNavigate();
  const [pet, setPet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showFullImage, setShowFullImage] = useState(false);
  const [showAdoptionForm, setShowAdoptionForm] = useState(false);

  useEffect(() => {
    const fetchPet = async () => {
      try {
        const petRef = ref(database, `pets/${petId}`);
        const snapshot = await get(petRef);
        if (snapshot.exists()) {
          setPet({ id: snapshot.key, ...snapshot.val() });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching pet details:", error);
        setLoading(false);
      }
    };

    fetchPet();
  }, [petId]);

  const nextImage = () => {
    if (pet?.images) {
      setCurrentImageIndex((prev) => 
        prev === pet.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (pet?.images) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? pet.images.length - 1 : prev - 1
      );
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!pet) {
    return (
      <div className="text-center py-10">
        <h2 className="text-2xl font-bold">Mascota no encontrada</h2>
        <button
          onClick={() => navigate('/')}
          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
        >
          Volver al inicio
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8">
          {/* Sección de Imágenes */}
          <div className="space-y-4">
            <div className="relative">
              <img
                src={pet.images[currentImageIndex]}
                alt={`${pet.name}`}
                className="w-full h-[600px] object-contain rounded-lg cursor-pointer"
                onClick={() => setShowFullImage(true)}
              />
              {pet.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-4 transition-all duration-200"
                  >
                    &#8249;
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-4 transition-all duration-200"
                  >
                    &#8250;
                  </button>
                </>
              )}
            </div>
            {/* Miniaturas de imágenes */}
            <div className="flex space-x-2 overflow-x-auto py-2">
              {pet.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Miniatura ${index + 1}`}
                  className={`h-20 w-20 object-cover rounded cursor-pointer transition-all duration-200 ${
                    currentImageIndex === index ? 'border-4 border-blue-500' : 'opacity-70 hover:opacity-100'
                  }`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>

          {/* Sección de Información */}
          <div className="space-y-6">
            <h1 className="text-4xl font-bold text-gray-800">
              {pet.name} - {PET_TYPES[pet.type]?.icon}
            </h1>
            <button
        onClick={() => setShowAdoptionForm(true)}
        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
      >
        Adoptar
      </button>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4">Información General</h2>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Color:</p>
                  <p>{pet.color}</p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Tamaño:</p>
                  <p>{PET_SIZES[pet.size]?.label}</p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Estado:</p>
                  <p>{PET_STATUS[pet.status]?.label}</p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Ubicación:</p>
                  <p>{pet.location}</p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Sexo:</p>
                  <p>{pet.sex === 'male' ? 'Macho' : 'Hembra'}</p>
                </div>
                <div className="space-y-2">
                  <p className="font-medium text-gray-700">Edad:</p>
                  <p>{pet.age}</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4">Descripción</h2>
              <p className="text-gray-700 leading-relaxed">{pet.description}</p>
            </div>

            {pet.notes && (
              <div className="bg-gray-50 p-6 rounded-lg">
                <h2 className="text-2xl font-semibold mb-4">Notas Adicionales</h2>
                <p className="text-gray-700 leading-relaxed">{pet.notes}</p>
              </div>
            )}

            
          </div>
        </div>

        {/* Botón Volver */}
        <div className="px-8 pb-8">
          <button
            onClick={() => navigate('/')}
            className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-full transition-colors duration-200"
          >
            ← Volver
          </button>
        </div>
      </div>

      {/* Modal de imagen completa */}
      {showFullImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={() => setShowFullImage(false)}
        >
          <img
            src={pet.images[currentImageIndex]}
            alt={`${pet.name} - Vista completa`}
            className="max-h-screen max-w-full object-contain"
          />
          <button
            className="absolute top-4 right-4 text-white text-4xl"
            onClick={() => setShowFullImage(false)}
          >
            ×
          </button>
        </div>
      )}

      {/* Modal de formulario de adopción */}
      {showAdoptionForm && (
        <AdoptionForm
          pet={pet}
          onClose={() => setShowAdoptionForm(false)}
        />
      )}


    </div>
  );
};

export default PetDetail;